import { useState } from 'react'
import { List, X } from '@phosphor-icons/react'
import { useMotionValueEvent, useScroll } from 'framer-motion'
import { scrollToSection } from '../utils/scrollTo'

const LINKS = [
  { href: '#tours', label: 'Tours' },
  { href: '#paquetes', label: 'Paquetes' },
  { href: '#nosotros', label: 'Nosotros' },
  { href: '#preguntas', label: 'Preguntas' },
]

export default function Navbar() {
  const { scrollY } = useScroll()
  const [solid, setSolid] = useState(false)
  const [open, setOpen] = useState(false)

  useMotionValueEvent(scrollY, 'change', (y) => {
    const next = y > 40
    if (next !== solid) setSolid(next)
  })

  const onDark = !solid && !open

  const go = (e, id) => {
    setOpen(false)
    scrollToSection(e, id)
  }

  return (
    <header
      className={`fixed inset-x-0 top-0 z-40 transition-colors duration-300 ${
        onDark ? 'bg-transparent text-white' : 'bg-white/90 text-navy-950 shadow-[0_1px_0_rgba(14,20,32,0.08)] backdrop-blur-md'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-18 md:px-8">
        <a href="#inicio" onClick={(e) => go(e, 'inicio')} className="flex items-center gap-2">
          <img
            src="/logo_despega.png"
            alt="Despega GT"
            className={`h-10 w-auto transition-[filter] duration-300 ${onDark ? 'brightness-0 invert' : ''}`}
          />
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => go(e, link.href.slice(1))}
              className={`text-sm font-medium transition-colors ${
                onDark ? 'text-white/80 hover:text-white' : 'text-navy-700/70 hover:text-navy-950'
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#cotizador"
            onClick={(e) => go(e, 'cotizador')}
            className="rounded-xl bg-sunset-500 px-5 py-2.5 text-sm font-semibold text-white transition-transform duration-150 hover:brightness-110 active:scale-[0.98]"
          >
            Pedir cotización
          </a>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={open}
          className={`grid h-10 w-10 place-items-center md:hidden ${onDark ? 'text-white' : 'text-navy-950'}`}
        >
          {open ? <X size={22} /> : <List size={22} />}
        </button>
      </div>

      {open && (
        <nav className="border-t border-navy-900/10 bg-white px-4 pb-6 pt-2 text-navy-950 md:hidden">
          <ul className="flex flex-col">
            {LINKS.map((link) => (
              <li key={link.href}>
                <a href={link.href} onClick={(e) => go(e, link.href.slice(1))} className="block py-3 text-base font-medium">
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#cotizador"
            onClick={(e) => go(e, 'cotizador')}
            className="mt-3 inline-flex rounded-xl bg-sunset-500 px-5 py-3 text-sm font-semibold text-white"
          >
            Pedir cotización
          </a>
        </nav>
      )}
    </header>
  )
}
